import * as React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import {
    withStyles, Typography, IconButton, Fab,
} from '@material-ui/core';
import classnames from 'classnames';

import { SkillIcon, InfoIcon, PlusIcon } from '../../../common/icons';

const styles = theme => ({
    module: {
        padding: theme.spacing(1),
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        background: theme.colors.grey2,
        position: 'relative',
    },
    disabled: {
        background: theme.palette.common.white,
        border: theme.borders.normal,
    },
    moduleIcon: {
        fontSize: theme.sizes.largeIcon,
        marginBottom: theme.spacing(1),
    },
    actionButton: {
        margin: theme.spacing(1),
    },
    infoIcon: {
        position: 'absolute',
        top: 0,
        left: 0,
        padding: theme.spacing(0.5),
    },
    name: {
        wordBreak: 'break-word',
    },
});

const getItemStyle = (draggableStyle, isDragging) => ({
    userSelect: 'none',
    background: isDragging ? '#efefef' : '',
    ...draggableStyle,
});

class DragableSkill extends React.Component {
    render() {
        const {
            classes, className, module, index, draggableId, disabled, showInfo, onAdd,
        } = this.props;

        if (!module) {
            return null;
        }

        return (
            <Draggable draggableId={disabled ? `${draggableId}_disabled` : draggableId} index={index} isDragDisabled={disabled}>
                {(provided, snapshot) => (
                    <div
                        className={classnames(classes.module, className, { [classes.disabled]: disabled })}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                            provided.draggableProps.style,
                            snapshot.isDragging,
                        )}
                    >
                        {showInfo && (
                            <IconButton onClick={showInfo} className={classes.infoIcon}>
                                <InfoIcon fontSize="small" />
                            </IconButton>
                        )}
                        {disabled ? <SkillIcon className={classes.moduleIcon} /> : (
                            <Fab onClick={onAdd} size="medium" color="primary" className={classes.actionButton} aria-label="Legg til">
                                <PlusIcon />
                            </Fab>
                        )}
                        <Typography className={classes.name}>
                            {module.name}
                        </Typography>
                    </div>
                )}
            </Draggable>
        );
    }
}

DragableSkill.propTypes = {
    classes: PropTypes.object.isRequired,
    module: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    draggableId: PropTypes.string.isRequired,
    onAdd: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    showInfo: PropTypes.func,
};

DragableSkill.defaultProps = {
    disabled: false,
    className: null,
    showInfo: null,
    onAdd: null,
};

export default withStyles(styles)(DragableSkill);
